module.exports = __webpack_public_path__ + "img/male.95798c9b.svg";